module.exports = __webpack_public_path__ + "static/media/questions.1e60df99.svg";